// src/components/dashboard/AutoActionLog.jsx — v9.2 FIXED
//
// ВОССТАНОВЛЕНО: PREVENTED €N в строке действия
//
// Обоснование:
//   "prevented €N" в AutoActionLog — это action detail (детали конкретного действия),
//   а НЕ глобальный KPI.
//   KPI = Budget Saved в HeroLayer = СУММА всех prevented_loss (€8,384 total)
//   Action detail = "это конкретное действие предотвратило €2,912"
//   Это разные данные — одно не заменяет другое.
//
// Формат строки:
//   [Spend Reduced] | RISK 0.91 | PREVENTED €2 912 | 5 Apr 14:32

import SectionTitle from "../ui/SectionTitle";
import Panel        from "../ui/Panel";

const ACTION_LABELS = {
  reduce_spend:    "Spend Reduced",
  monitor:         "Monitoring",
  limit_budget:    "Budget Limited",
  pause_campaigns: "Campaigns Paused",
};

const ACTION_COLORS = {
  reduce_spend:    "var(--warning)",
  monitor:         "var(--accent-primary)",
  limit_budget:    "var(--warning)",
  pause_campaigns: "var(--danger)",
};

function safeJson(v) {
  if (!v) return null;
  if (typeof v === "object") return v;
  try { return JSON.parse(v); } catch { return null; }
}

function fmtPrevented(v) {
  if (typeof v !== "number" || isNaN(v)) return "—";
  return `€ ${Math.abs(Math.round(v)).toLocaleString("en-US")}`;
}

export default function AutoActionLog({ actions = [], loading }) {
  return (
    <div>
      {/* A3: false pauses counter */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:4 }}>
        <SectionTitle title="Protection Events" />
        {Array.isArray(actions) && (() => {
          const n = actions.filter(a => a.action_type === "monitor" || a.action_type === "observe").length;
          return n > 0 ? (
            <div style={{ fontFamily:"var(--font-mono)", fontSize:9, color:"var(--success)",
                          padding:"2px 8px", borderRadius:"var(--radius-sm)",
                          background:"var(--success-bg)", border:"1px solid var(--success-border)" }}>
              {n} false pause{n !== 1 ? "s" : ""} prevented
            </div>
          ) : null;
        })()}
      </div>
      <Panel style={{ padding: 0, minHeight: 80 }}>
        {loading ? (
          <div style={{ padding: "16px 20px", display: "flex", flexDirection: "column", gap: 8 }}>
            {[1, 2, 3].map(i => (
              <div key={i} className="skeleton" style={{ height: 40, borderRadius: "var(--radius)" }} />
            ))}
          </div>
        ) : !actions.length ? (
          <div style={{ padding: "20px", fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--text-muted)" }}>
            No auto-actions recorded
          </div>
        ) : (
          <div>
            {actions.slice(0, 10).map((a, idx) => {
              const type      = a.action_type ?? "unknown";
              const label     = ACTION_LABELS[type] ?? type.replace(/_/g, " ");
              const color     = ACTION_COLORS[type] ?? "var(--text-secondary)";
              const ts        = a.timestamp
                ? new Date(a.timestamp * 1000).toLocaleString("en-GB", {
                    day: "2-digit", month: "short",
                    hour: "2-digit", minute: "2-digit",
                  })
                : "—";
              const risk      = typeof a.risk_score === "number"
                ? a.risk_score.toFixed(2)
                : "—";
              // RESTORED: prevented_loss — это action detail, не глобальный KPI
              const prevented = fmtPrevented(a.prevented_loss);

              return (
                <div key={a.id ?? idx} style={{
                  padding: "12px 20px",
                  borderBottom: idx < Math.min(actions.length, 10) - 1
                    ? "1px solid var(--border-subtle)"
                    : "none",
                  display: "flex", alignItems: "center", gap: 16,
                }}>
                  {/* Action type badge */}
                  <span style={{
                    padding: "3px 8px", borderRadius: "var(--radius-sm)",
                    background: `${color}15`, border: `1px solid ${color}30`,
                    fontFamily: "var(--font-mono)", fontSize: 9, fontWeight: 700,
                    letterSpacing: "0.1em", color, textTransform: "uppercase",
                    flexShrink: 0, whiteSpace: "nowrap", minWidth: 110, textAlign: "center",
                  }}>
                    {label}
                  </span>

                  {/* Risk score */}
                  <div style={{ display: "flex", flexDirection: "column", minWidth: 48 }}>
                    <div style={{
                      fontFamily: "var(--font-mono)", fontSize: 9,
                      color: "var(--text-muted)", marginBottom: 2,
                    }}>
                      RISK
                    </div>
                    <div style={{
                      fontFamily: "var(--font-mono)", fontSize: 13,
                      fontWeight: 700, color: "var(--danger)",
                    }}>
                      {risk}
                    </div>
                  </div>

                  {/* PREVENTED — action detail (сколько предотвратило именно это действие) */}
                  <div style={{ display: "flex", flexDirection: "column", minWidth: 72 }}>
                    <div style={{
                      fontFamily: "var(--font-mono)", fontSize: 9,
                      color: "var(--text-muted)", marginBottom: 2,
                    }}>
                      PREVENTED
                    </div>
                    <div style={{
                      fontFamily: "var(--font-mono)", fontSize: 13,
                      fontWeight: 700, color: "var(--success)",
                    }}>
                      {prevented}
                    </div>
                  </div>

                  {/* Timestamp */}
                  <div style={{
                    flex: 1,
                    fontFamily: "var(--font-mono)", fontSize: 10,
                    color: "var(--text-muted)", whiteSpace: "nowrap",
                    textAlign: "right",
                  }}>
                    {ts}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Panel>
    </div>
  );
}
